import React from 'react';
import { Spin, Button } from 'antd';
import { usePaymentTypes } from '../../api/paymentTypesQuery';

const ErrorBlock = ({ refetch }) => {
  return (
    <div>
      <p style={{ color: '#f5222d' }}>Не удалось получить способы оплаты</p>
      <Button
        type="primary"
        onClick={refetch}
      >
        Попробовать снова
      </Button>
    </div>
  );
};

const PaymentTypesFetcher = ({ requestId, children }) => {
  const { data, isFetching, refetch } = usePaymentTypes(
    { requestId },
    {
      enabled: Boolean(requestId),
      staleTime: Infinity,
      notifyOnChangeProps: ['data', 'isFetching'],
    }
  );

  return (
    <Spin spinning={Boolean(isFetching)}>
      {data === 'Error' ? (
        <ErrorBlock refetch={refetch} />
      ) : (
        children({ types: data?.paymentTypes })
      )}
    </Spin>
  );
};

export default PaymentTypesFetcher;
